import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { crmApi } from '../services/crmApi';
import authSlice from './authSlice';
import customerSlice from './customerSlice';
import { rtkQueryErrorLogger } from './rtkQueryErrorLogger';

export const storeConfig = {
    reducer: {
        customer: customerSlice,
        auth: authSlice,
        [crmApi.reducerPath]: crmApi.reducer,
    },
    devTools: process.env.NODE_ENV !== 'production',
};

export const store = configureStore({
    ...storeConfig,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(crmApi.middleware).concat(rtkQueryErrorLogger),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
